import React, { useEffect, useRef, useState } from "react";
import { Rnd } from "react-rnd";
import styled from "styled-components";
import getIdYoutube from "../../../../utils/getIdYoutube";
import { RxDragHandleDots2 } from "react-icons/rx";
import { showPopupType } from "../../Sidebar";
import { getDataYoutube } from "../../../../api/youtubeApi";
import YouTube from "react-youtube";
import isValidYouTubeURL from "../../../../utils/isValidYouTubeURL";
import { toast } from "react-toastify";
import { setKeyToLocalStorage } from "../../../../utils/setKeyToLocalStorage";
import { getKeyFromLocalStorage } from "../../../../utils/getKeyFromLocalStorage";

interface YoutubeProps {
  show: boolean;
  onShow: React.Dispatch<React.SetStateAction<showPopupType>>;
}
export const YtbKey = {
  playlistYtb: "playlistYtb",
};

interface IYoutube {
  id: string;
  image: string;
  title: string;
}
const opts = {
  playerVars: {
    autoplay: 1,
  },
};
const Youtube = ({ show = false, onShow }: YoutubeProps) => {
  const [youtubeUrl, setYoutubeUrl] = useState<string>("");
  const [submit, setSubmit] = useState<boolean>(false);
  const [playlistYoutube, setPlaylistYoutube] = useState<IYoutube[]>([]);
  const [ytbId, setYtbId] = useState<string>("");
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!youtubeUrl || !youtubeUrl.trim()) {
      return;
    }
    const isValidYtbUrl = isValidYouTubeURL(youtubeUrl);
    if (!isValidYtbUrl && !playlistYoutube.length) {
      toast.warning("invalid video 🙁", {
        autoClose: 1500,
        position: "top-center",
      });
      return;
    }
    if (!isValidYtbUrl) {
      toast.warning("invalid video 🙁", {
        autoClose: 1500,
        position: "top-center",
      });
    } else {
      let idYtb = getIdYoutube(youtubeUrl);
      if (idYtb) {
        setYtbId(idYtb);
      }
    }
    setSubmit(true);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setYoutubeUrl(event.target.value);
  };
  const handleReset = () => {
    setSubmit(false);
    setYoutubeUrl("");
  };
  const handlePlayVideoItem = (id: string) => {
    setYtbId(id);
  };
  const handleOnEndedVideo = () => {
    let index = playlistYoutube.findIndex((item) => item.id === ytbId);
    if (index !== -1) {
      if (index >= playlistYoutube.length - 1) {
        let newId = playlistYoutube[0].id;
        setYtbId(newId);
      } else {
        let newId = playlistYoutube[index + 1].id;
        setYtbId(newId);
      }
    }
  };
  const handleDeleteVideo = (currId: string) => {
    if (currId === ytbId) {
      return;
    }

    const newArr = playlistYoutube.filter((video) => video.id !== currId);
    setPlaylistYoutube(newArr);
    setKeyToLocalStorage(YtbKey.playlistYtb, newArr);
    if (playlistYoutube.length === 0) {
      setYtbId("");
    }
  };
  useEffect(() => {
    const playlistYtb = getKeyFromLocalStorage(YtbKey.playlistYtb);
    if (playlistYtb) {
      setPlaylistYoutube(playlistYtb);
      setYtbId(playlistYtb[0].id);
    }
  }, []);

  React.useEffect(() => {
    if (!youtubeUrl || !youtubeUrl.trim()) {
      return;
    }
    async function fetchDataYoutube() {
      try {
        let idYoutube = getIdYoutube(youtubeUrl);
        if (!idYoutube) {
          return;
        }
        const response = await getDataYoutube(idYoutube as string);
        if (response && response?.items) {
          const { id, snippet } = response.items[0];
          let checkExist = playlistYoutube.some((iYtb) => iYtb.id === id);
          const youtubeItem = {
            id: id,
            title: snippet?.localized?.title,
            image: snippet?.thumbnails?.high?.url,
          };
          if (!checkExist) {
            const updatePlaylistYtb = [...playlistYoutube, youtubeItem];
            setPlaylistYoutube(updatePlaylistYtb);
            setKeyToLocalStorage(YtbKey.playlistYtb, updatePlaylistYtb);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
    fetchDataYoutube();
  }, [youtubeUrl]);

  console.log(playlistYoutube);

  return (
    <Rnd
      default={{
        x: -window.screen.width / 2 - 100,
        y: 0,
        width: 390,
        height: submit && youtubeUrl !== "" ? 300 : 59,
      }}
      maxWidth={submit ? 3000 : 390}
      minHeight={submit ? 375 : 59}
      enableResizing={{
        bottomRight: submit ? true : false,
        right: true,
        bottom: true,
      }}
      style={{
        visibility: show ? "visible" : "hidden",
        borderRadius: "12px",
      }}
      className="px-2 py-0  rounded-md "
    >
      <StyledYoutube className="relative h-full w-full">
        {!submit && (
          <div className="w-full h-full youtube-url   py-[11px] pl-2 pr-6 rounded-md flex items-center justify-between  relative">
            <div className="flex w-full flex-col gap-y-4">
              <form onSubmit={handleSubmit} className="w-[95%] relative">
                <input
                  value={youtubeUrl}
                  onChange={handleChange}
                  className="w-full text-white px-3 py-[6px] rounded-md text-xs bg-[#2C2C2C] outline-none"
                  placeholder="Paste a YouTube video URL here and press enter"
                  type="text"
                />
                <i
                  onClick={() =>
                    onShow((prev) => {
                      return {
                        ...prev,
                        showYoutubePop: !prev.showYoutubePop,
                      };
                    })
                  }
                  className="bi text-textSecondary hover:text-white text-base cursor-pointer absolute -right-[30px] top-2/4 -translate-y-2/4 bi-x-lg"
                ></i>
              </form>
            </div>
          </div>
        )}
        {submit && (
          <div className="w-full  flex-col gap-y-4 relative h-full youtube-url pb-3 pt-7 px-3 rounded-md flex items-center justify-between">
            <YouTube
              onEnd={handleOnEndedVideo}
              className="w-full h-full"
              videoId={ytbId}
              opts={opts}
            />

            <div className="absolute flex gap-x-3 items-center right-[14px] top-[2px]">
              <i
                onClick={handleReset}
                className="bi bi-search text-textSecondary hover:text-white text-base cursor-pointer"
              ></i>
              <i
                onClick={() =>
                  onShow((prev) => {
                    return {
                      ...prev,
                      showYoutubePop: !prev.showYoutubePop,
                    };
                  })
                }
                className="bi text-textSecondary hover:text-white text-base cursor-pointer bi-x-lg"
              ></i>
            </div>
            <div className="absolute change-position text-textSecondary text-lg cursor-pointer left-2/4 flex pointer-events-none  items-center top-[5px] -translate-x-2/4 flex-col">
              <RxDragHandleDots2 className="change-position rotate-[90deg]" />
            </div>
            <div className="playlist-youtube  h-[150px] has-scrollbar-ytb w-full">
              {playlistYoutube?.length > 0 &&
                playlistYoutube?.map((iYtb) => {
                  return (
                    <div
                      key={iYtb.id}
                      className={`${
                        iYtb.id === ytbId ? "active" : ""
                      } youtube-item  gap-x-2  select-none cursor-pointer  border-b border-bordermood transition-all rounded-sm p-[6px] flex items-center justify-between`}
                    >
                      <div className="flex items-center gap-x-3">
                        <div className="youtube-thumb rounded-sm flex-shrink-0 w-10 h-10  relative">
                          <img
                            className="rounded-sm w-full h-full"
                            src={iYtb.image}
                            alt=""
                          />
                        </div>
                        <div className="youtube-name hover:text-primary text-sm font-medium  text-white flex flex-col">
                          {iYtb.title}
                        </div>
                      </div>
                      <div className="youtube-action gap-x-3 flex items-center  text-textSecondary ">
                        <div className="relative">
                          {iYtb.id === ytbId ? (
                            <i className="bi text-inherit text-lg bi-pause-circle text-white transition-all hover:text-primary"></i>
                          ) : (
                            <i
                              onClick={() => handlePlayVideoItem(iYtb.id)}
                              className="bi text-inherit text-lg bi-play-circle text-white transition-all hover:text-primary"
                            ></i>
                          )}
                        </div>
                        <i
                          onClick={() => handleDeleteVideo(iYtb.id)}
                          className={`bi text-lg text-white hover:text-primary transition-all bi-trash ${
                            iYtb.id === ytbId
                              ? "cursor-not-allowed opacity-50"
                              : ""
                          }`}
                        ></i>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </StyledYoutube>
    </Rnd>
  );
};

export default React.memo(Youtube);
const StyledYoutube = styled.div`
  iframe {
    width: 100%;
    height: 100%;
  }
  .youtube-url {
    background: rgba(18, 18, 18, 0.75);
    backdrop-filter: blur(30px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  .change-position {
    transform: translate(90deg);
  }
  .youtube-item.active {
    .youtube-name {
      color: #f3a952;
    }
  }
  .youtube-name {
    overflow: hidden;
    white-space: wrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Số dòng tối đa  muốn hiển thị */
    -webkit-box-orient: vertical;
  }
`;
